
import { RevButton } from '@ds/components/Button'
import { RevButtonBase } from '@ds/components/ButtonBase'
import { RevCard } from '@ds/components/Card'
import { RevIllustration } from '@ds/components/Illustration'
import { RevTag } from '@ds/components/Tag'
import { IconShoppingBag } from '@ds/icons/IconShoppingBag'

import PriceWithCrossedPrice from './PriceWithCrossedPrice/PriceWithCrossedPrice.vue'
import translations from './ProductCard.translations'

export default {
  components: {
    RevButton,
    RevButtonBase,
    RevIllustration,
    RevCard,
    RevTag,
    PriceWithCrossedPrice,
  },
  props: {
    link: {
      type: Object,
      required: true,
    },
    tags: {
      type: Array,
      default: () => [],
    },
    imageAlt: {
      type: String,
      default: 'alt text is missing',
    },
    imageSrc: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
    grade: {
      type: String,
      default: '',
    },
    price: {
      type: Object,
      required: true,
    },
    referencePrice: {
      type: Object,
      default: undefined,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    cardWidth: {
      type: String,
      default: 'standard',
    },
    withStartingFrom: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      isFocused: false,
    }
  },

  computed: {
    translations: () => translations,

    IconShoppingBag: () => IconShoppingBag,

    withAddToCart() {
      return this.$listeners['add-to-cart'] !== undefined
    },

    isNarrow() {
      return this.cardWidth === 'narrow'
    },
  },
}
